import Axios from "axios";
import {
  SET_LC_IMPORT_PI_LIST,
  UNSET_LC_IMPORT_PI_LIST,
  SET_EDITING_LC_IMPORT_PI,
  UNSET_EDITING_LC_IMPORT_PI,
} from "@/store/mutation-types";
import {
  saveUpdateLcImportPi,
  getLcImportPiList,
  getLcImportPiById as getLcImportPiByIdApi,
} from "@/store/api";

// initial state
const state = {
  lcImportPiList: [],
  editingLcImportPi: null,
};

const getters = {
  getLcImportPiList(state) {
    return state.lcImportPiList;
  },
  getEditingLcImportPi(state) {
    return state.editingLcImportPi;
  },
};

const mutations = {
  [SET_LC_IMPORT_PI_LIST](state, data) {
    state.lcImportPiList = data;
  },
  [UNSET_LC_IMPORT_PI_LIST](state) {
    state.lcImportPiList = [];
  },
  [SET_EDITING_LC_IMPORT_PI](state, data) {
    state.editingLcImportPi = data;
  },
  [UNSET_EDITING_LC_IMPORT_PI](state) {
    state.editingLcImportPi = null;
  },
};

const actions = {
  saveUpdateLcImportPi({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcImportPi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcImportPiList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcImportPiList)
        .then(function (response) {
          commit(SET_LC_IMPORT_PI_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_IMPORT_PI_LIST);
          reject(error);
        });
    });
  },

  getLcImportPiById({ commit }, id) {
    const url = `${getLcImportPiByIdApi}${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          commit(SET_EDITING_LC_IMPORT_PI, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

